export const SIGN_UP_REQUEST = 'SIGN_UP_REQUEST';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';

export const GET_SIGN_UP_REGISTRATION_FORM_REQUEST = 'GET_SIGN_UP_REGISTRATION_FORM_REQUEST';
export const GET_SIGN_UP_REGISTRATION_FORM_SUCCESS = 'GET_SIGN_UP_REGISTRATION_FORM_SUCCESS';
export const GET_SIGN_UP_REGISTRATION_FORM_FAILURE = 'GET_SIGN_UP_REGISTRATION_FORM_FAILURE';
